import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Sidebar from "../sidebar";
import DefaultModal from "../default_modal";
import { useAppVersions } from "../../hooks/useAppVersions";
import { VersionForm } from "./VersionForm";
import { VersionList } from "./VersionList";
import {
  MainContainer,
  BackgroundPattern,
  SideContainer,
  PageContent,
  ButtonRow,
  ButtonContainerLeft,
  ButtonContainerRight,
  StyledButton,
  HeaderSection,
  Title,
  Subtitle,
  FormCard,
} from "./styles";
import { useFullscreenState } from "../../utils/fullscreen";

export default function AppVersionsPanel() {
  const collapsed = useSelector((state) => state.sidebar);
  const navigate = useNavigate();
  const { versions, loading, error, reload, versionExists } = useAppVersions();
  const [showForm, setShowForm] = useState(false);
  const { fullscreenActive, toggleFullscreen } = useFullscreenState();

  function handleCreated() {
    setShowForm(false);
    reload();
  }

  return (
    <MainContainer collapsed={collapsed}>
      <BackgroundPattern />
      <Sidebar />
      <SideContainer collapsed={collapsed}>
        <PageContent>
          <ButtonRow>
            <ButtonContainerLeft>
              <StyledButton type="button" onClick={() => navigate("/settings")}>
                Voltar
              </StyledButton>
            </ButtonContainerLeft>
            <ButtonContainerRight>
              <StyledButton type="button" onClick={() => setShowForm(true)}>
                <span style={{ marginRight: "8px" }}>+</span>
                Nova versão
              </StyledButton>
            </ButtonContainerRight>
          </ButtonRow>

          <HeaderSection>
            <Title>Controle de Versões</Title>
            <Subtitle>
              Gerencie as versões publicadas do aplicativo e as atualizações obrigatórias.
            </Subtitle>
          </HeaderSection>

          <VersionList
            versions={versions}
            loading={loading}
            error={error}
            reload={reload}
          />
        </PageContent>
      </SideContainer>

      <DefaultModal isOpen={showForm} onClose={() => setShowForm(false)}>
        <FormCard>
          <h2 style={{ textAlign: "center" }}>Nova versão</h2>
          <VersionForm versionExists={versionExists} onCreated={handleCreated} />
        </FormCard>
      </DefaultModal>
    </MainContainer>
  );
}